export default __webpack_public_path__ + "static/media/DSC_91130.16199274.jpg";